import React, { useState, useCallback, useEffect } from 'react';
import { Tabs, Tab, Box, Typography, Container, Grid, Card, Alert, Button, Dialog, Tooltip } from '@mui/material';
import { useParams } from 'react-router-dom';
import BusinessInformation from './business_information';
import ManageLicense from './manage_license';
import UserMapping from './user_mapping';
import Settings from './settings';
import { makeStyles } from '@mui/styles';
import { useDispatch, useSelector } from 'react-redux';
import { showLoader, hideLoader } from '../../../redux/loader/actions';
import { showSnackbar } from '../../../redux/snackbar/actions';
import getbusinessuuidApi from '../../../services/managelicense/index';
import getlicensebusinessuuidApi from '../../../services/managelicense/index';
import { setEncryptedCookie, getDecryptedCookie, removeCookie } from '../../../utils';
import productApi from '../../../services/product';
import subscriptionApi from '../../../services/subscribe';
import authApi from '../../../services/auth';
import { setAuth } from '../../../redux/common/actions';
import PriceDetails from '../price_modal';
import BusinessSelection from '../../signin/business_selection';

const useStyles = makeStyles({
    ribbonContainer: {
        position: 'relative',
        display: 'inline-block'
    },
    ribbon: {
        position: 'absolute',
        top: '10px',
        left: '0px',
        background: 'linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)',
        color: 'white',
        padding: '5px 20px',
        fontSize: '24px',
        fontWeight: 'bold',
        clipPath: 'polygon(0 0, 100% 0, 95% 100%, 0 100%)',
        zIndex: 1,
        whiteSpace: 'nowrap'
    }
});

const TabContent = (props) => {
    const {
        index,
        onNext,
        onPrevious,
        formData,
        setFormData,
        businesssid,
        licensebusinesssid,
        busTitle,
        setBusTitle,
        isEditing,
        setIsEditing,
        smsStatus,
        whatsappStatus,
        mailStatus,
        handleSmsCheckboxChange,
        handleWhatsappCheckboxChange,
        handleMailCheckboxChange,
        bas,
        bass,
        setBas,
        setBass,
        setLanguageType,
        languageType,
        loanNumberType,
        setLoanNumberType
    } = props;

    switch (index) {
        case 0:
            return (
                <BusinessInformation
                    onNext={onNext}
                    formData={formData}
                    setFormData={setFormData}
                    businesssid={businesssid}
                    busTitle={busTitle}
                    setBusTitle={setBusTitle}
                    isEditing={isEditing}
                    setIsEditing={setIsEditing}
                    bas={bas}
                    bass={bass}
                    setBas={setBas}
                    setBass={setBass}
                    setLanguageType={setLanguageType}
                    languageType={languageType}
                    loanNumberType={loanNumberType}
                    setLoanNumberType={setLoanNumberType}
                />
            );
        case 1:
            return (
                <ManageLicense
                    onPrevious={onPrevious}
                    onNext={onNext}
                    formData={formData}
                    setFormData={setFormData}
                    licensebusinesssid={licensebusinesssid}
                    businesssid={businesssid}
                    setLanguageType={setLanguageType}
                    languageType={languageType}
                    loanNumberType={loanNumberType}
                    setLoanNumberType={setLoanNumberType}
                />
            );
        case 2:
            return <UserMapping onPrevious={onPrevious} onNext={onNext} />;
        case 3:
            return (
                <Settings
                    onPrevious={onPrevious}
                    smsStatus={smsStatus}
                    whatsappStatus={whatsappStatus}
                    mailStatus={mailStatus}
                    handleSmsCheckboxChange={handleSmsCheckboxChange}
                    handleWhatsappCheckboxChange={handleWhatsappCheckboxChange}
                    handleMailCheckboxChange={handleMailCheckboxChange}
                />
            );
        default:
            return null;
    }
};

const ProductConfig = () => {
    const { productid, busUid, businessuuid, status } = useParams();
    const classes = useStyles();
    const [tabIndex, setTabIndex] = useState(0);
    const [logoID, setLogoID] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const dispatch = useDispatch();
    const [languageType, setLanguageType] = useState();
    const [loanNumberType, setLoanNumberType] = useState('general');

    const [planId, setPlanId] = useState();
    const [planData, setPlanData] = useState({
        productName: '',
        plan: ''
    });
    const [subUUID, setSubUUID] = useState();
    const [openPriceDetailsModal, setOpenPriceDetailsModal] = useState(false);
    const [busUUID, setBusUUID] = useState();
    const [selectedPlanDetails, setSelectedPlanDetails] = useState();
    const [filteredPlans, setFilteredPlans] = useState([]);
    const [renewPlanOff, setRenewPlanOff] = useState();
    const [productDetails, setProductDetails] = useState([]);
    const [renewPlan, setRenewPlan] = useState();
    const organizationItems = useSelector((state) => state.organizationReducer.items);
    const expiryData = useSelector((state) => state.expiryReducer.items);
    const [verifyModal, setVerifyModal] = useState(false);
    const [selectedOption, setSelectedOption] = useState('');
    const handleRenew = () =>
        // action,
        // busid,
        // uuid,
        // planid,
        // productName,
        // plan,
        // sub_uuid,
        // renew
        {
            removeCookie('proid');
            setOpenPriceDetailsModal(true);
            getPlanDetails(expiryData?.proId);
            setBusUUID(expiryData?.busId);
            setPlanId(expiryData?.planId);
            setPlanData({ productName: expiryData?.product, plan: expiryData?.plan });
            setSubUUID(expiryData?.subuuid);
            setEncryptedCookie('upgrade', expiryData?.busid);
            setEncryptedCookie('proid', expiryData?.proId, {
                expires: 7
            });
            setEncryptedCookie('puuid', expiryData?.proId);
            setEncryptedCookie('suuid', expiryData?.subuuid);
            setSelectedPlanDetails(expiryData?.renewDetails);
        };

    const getPlanDetails = (productUUID) => {
        dispatch(showLoader());
        subscriptionApi
            .getPlanFeatures(productUUID)
            .then((res) => {
                dispatch(hideLoader());
                setFilteredPlans(res.data.data);
                setRenewPlanOff(res.data.package);
                setProductDetails(res.data.product);
            })
            .catch((err) => {
                dispatch(hideLoader());
                console.error('Error response:', err);
            });
    };

    useEffect(() => {
        if (planId && filteredPlans.length > 0) {
            const plan = filteredPlans.find((plan) => plan?.product_plan_uuid === planId);
            if (plan) {
                setRenewPlan(plan);
            } else {
                console.log('Plan not found with planId:', planId);
            }
        }
    }, [filteredPlans, planId]);

    const backup = getDecryptedCookie('bup');

    useEffect(() => {
        if (backup) {
            deleteFunction();
        }
    }, []);
    const deleteFunction = () => {
        const data = {
            business_uuid: businessuuid,
            subscription_type: 'trial'
        };
        const onSuccess = (res) => {
            dispatch(hideLoader());
            if (res?.data?.status) {
                dispatch(
                    showSnackbar({
                        message: res?.data?.msg,
                        autoHideDuration: 3000,
                        anchorOrigin: {
                            vertical: 'top',
                            horizontal: 'right'
                        },
                        variant: 'success'
                    })
                );
                removeCookie('bup');
            }
        };
        const onFailure = (err) => {
            dispatch(hideLoader());
            dispatch(
                showSnackbar({
                    message: err?.response?.data?.msg,
                    autoHideDuration: 3000,
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    },
                    variant: 'success'
                })
            );
            console.log(err?.response?.data?.data?.msg);
        };
        subscriptionApi?.deleteSubscribe(proid, data).then(onSuccess, onFailure);
    };

    const [businesssid, setBusinesssid] = useState([]);
    const [licensebusinesssid, setLicenseBusinesssid] = useState([]);
    const [busTitle, setBusTitle] = useState([]);
    const [formData, setFormData] = useState({
        businessname: '',
        businessaliasname: '',
        gstin: '',
        address: '',
        mobilenumber: '',
        inputlanguage: '',
        businesslogo: null
    });

    const [smsStatus, setSmsStatus] = useState({
        smsloanOpen: false,
        smsloanClose: false,
        smsoverDue: false,
        smsgeneralReminder: false
    });

    const [whatsappStatus, setWhatsappStatus] = useState({
        whatsapploanOpen: false,
        whatsapploanClose: false,
        whatsappoverDue: false,
        whatsappgeneralReminder: false
    });

    const [mailStatus, setMailStatus] = useState({
        mailloanOpen: false,
        mailloanClose: false,
        mailoverDue: false,
        mailgeneralReminder: false
    });

    const handleSmsCheckboxChange = (field) => {
        setSmsStatus((prevState) => ({
            ...prevState,
            [field]: !prevState[field]
        }));
    };

    const handleWhatsappCheckboxChange = (field) => {
        setWhatsappStatus((prevState) => ({
            ...prevState,
            [field]: !prevState[field]
        }));
    };

    const handleMailCheckboxChange = (field) => {
        setMailStatus((prevState) => ({
            ...prevState,
            [field]: !prevState[field]
        }));
    };

    const handleNext = () => {
        if (tabIndex < 3) setTabIndex(tabIndex + 1);
    };

    const handlePrevious = () => {
        if (tabIndex > 0) setTabIndex(tabIndex - 1);
    };

    const enableTabs = sessionStorage.getItem('enableManageLicense');
    const handleTabChange = (event, newIndex) => {
        if (enableTabs) {
            setTabIndex(newIndex);
        }
    };
    const businessid = getDecryptedCookie('bi');
    const business_uuid = busUid;
    const proid = productid;

    const validateUserToken = () => {
        dispatch(showLoader());
        const onSuccess = (res) => {
            if (res?.data?.status === true) {
                if (!res?.data?.has_access_in_current_id && res?.data?.has_access_in_other_id) {
                    setVerifyModal(true);
                }
            }
            dispatch(
                setAuth({
                    isAuthenticated: true
                })
            );
        };
        const onFailure = (err) => {
            dispatch(hideLoader());
        };
        authApi.validateToken().then(onSuccess, onFailure);
    };

    useEffect(() => {
        validateUserToken();
    }, []);

    const getBusinessData = useCallback((businessuuid) => {
        const onSuccess = (res) => {
            if (res?.data?.status) {
                setBusTitle(res?.data?.data);
            }
        };
        const onFailure = (err) => {};
        console.log(productid, busUid, businessuuid, status, '000');

        productApi.getBusinessName(businessuuid).then(onSuccess, onFailure);
    }, []);

    useEffect(() => {
        getBusinessData(businessuuid);
    }, [businessuuid, organizationItems]);

    const getLicensebusinessId = useCallback(() => {
        const onSuccess = (res) => {
            if (res.data.status) {
                setLicenseBusinesssid(res.data.data?.data);
                removeCookie('ci');
                setEncryptedCookie('ci', res.data.data.uuid, { expires: 7 });
            }
        };

        const onFailure = (err) => {
            console.error('Failed to fetch data', err);
        };

        getbusinessuuidApi
            .getLicensebusinessId(proid, businesssid?.data?.[0]?.business_uuid)
            .then(onSuccess)
            .catch(onFailure);
    }, [businesssid, proid]);

    const [bas, setBas] = useState();
    const [bass, setBass] = useState();
    const getbusinessuuid = useCallback((proid, businessuuid) => {
        dispatch(showLoader());
        const onSuccess = (res) => {
            dispatch(hideLoader());
            if (res.data.status) {
                setBusinesssid(res.data.data);
                setEncryptedCookie('bi', res?.data?.data?.data[0]?.business_uuid, {
                    expires: 7
                });
                setEncryptedCookie('print', res?.data?.data?.data[0]?.business_uuid, {
                    expires: 7
                });
                setEncryptedCookie('lll', res?.data?.data?.data[0]?.inputlanguage);
                setEncryptedCookie('bas', res?.data?.data?.data[0]?.business_uuid, {
                    expires: 7
                });
                setBas(res?.data?.data?.data[0]?.business_uuid);
                setEncryptedCookie('bass', res?.data?.data?.data[0]?.sso_business_uuid, {
                    expires: 7
                });
                setBass(res?.data?.data?.data[0]?.sso_business_uuid);
            }
        };

        const onFailure = (err) => {
            dispatch(hideLoader());
            console.error('Failed to fetch data', err);
        };

        getbusinessuuidApi.getbusinessId(proid, businessuuid).then(onSuccess).catch(onFailure);
    }, []);

    useEffect(() => {
        getbusinessuuid(proid, businessuuid);
    }, [getbusinessuuid, organizationItems]);

    useEffect(() => {
        if (tabIndex === 0) {
            getbusinessuuid(proid, businessuuid);
        }
    }, [tabIndex, proid, businessuuid, getbusinessuuid]);

    const isGstinNull = businesssid?.data?.[0]?.bus_gst_in === null;

    return (
        <>
            <Container maxWidth='xl' sx={{ display: 'flex', flexDirection: 'column' }}>
                <Grid item xs={12} mb={2}>
                    <Box className={classes.ribbonContainer}>
                        <Box className={classes.ribbon}>
                            <Typography variant='body2'>Pawn Broking Application</Typography>
                        </Box>
                    </Box>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={6}></Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <Typography variant='body1' sx={{ textAlign: 'right' }}>
                                Business Name - {busTitle ? busTitle?.business_name : 'N/A'}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                {status === 'expired' && (
                    <Grid item xs={12}>
                        <Alert
                            variant='outlined'
                            severity='error'
                            sx={{
                                my: 1,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                padding: '6px, 10px'
                            }}
                        >
                            <Typography component='span'>Subscription expired. Kindly renew it.</Typography>
                            <Button
                                onClick={handleRenew}
                                sx={{
                                    ml: 2, // Add margin between text and button
                                    background: 'linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)',
                                    color: '#fff',
                                    padding: '6px 15px',
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    textTransform: 'none',
                                    borderRadius: '5px',
                                    transition: 'transform 0.3s ease',
                                    '&:hover': {
                                        // transform: "scale(1.025)",
                                        background: 'linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)'
                                    }
                                }}
                            >
                                Renew Now
                            </Button>
                        </Alert>
                    </Grid>
                )}
                <Card elevation={3}>
                    <Box sx={{ flexGrow: 1, mt: 1 }}>
                        <Tabs
                            value={tabIndex}
                            onChange={(e, newValue) => {
                                if (newValue === 1 && enableTabs === 'false') return;
                                handleTabChange(e, newValue);
                            }}
                            variant='scrollable'
                            scrollButtons='auto'
                            sx={{
                                borderBottom: 1,
                                borderColor: 'divider',
                                '& .MuiTabs-indicator': {
                                    height: 4,
                                    borderRadius: '5px',
                                    background: 'linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)'
                                },
                                '& .MuiTab-root.Mui-selected': {
                                    color: 'primary.main',
                                    fontWeight: 'bold'
                                }
                            }}
                        >
                            <Tab label='Business Information' sx={{ flexBasis: '25%' }} />

                            <Tooltip
                                title='Please complete the Business Information before accessing the License section'
                                arrow
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            fontSize: 13,
                                            maxWidth: 500
                                        }
                                    }
                                }}
                                disableHoverListener={enableTabs !== 'false'}
                            >
                                <Tab
                                    label='Manage License'
                                    sx={{
                                        flexBasis: '25%',
                                        color: enableTabs === 'false' ? 'text.disabled' : 'inherit'
                                    }}
                                />
                            </Tooltip>

                            <Tab label='User Mapping' sx={{ flexBasis: '25%' }} />
                            <Tab label='Settings' sx={{ flexBasis: '25%' }} />
                        </Tabs>

                        <Box sx={{ p: 3 }}>
                            <TabContent
                                index={tabIndex}
                                onNext={handleNext}
                                onPrevious={handlePrevious}
                                formData={formData}
                                setFormData={setFormData}
                                businesssid={businesssid}
                                licensebusinesssid={licensebusinesssid}
                                setBusTitle={setBusTitle}
                                busTitle={busTitle}
                                isEditing={isEditing}
                                setIsEditing={setIsEditing}
                                smsStatus={smsStatus}
                                whatsappStatus={whatsappStatus}
                                mailStatus={mailStatus}
                                handleSmsCheckboxChange={handleSmsCheckboxChange}
                                handleWhatsappCheckboxChange={handleWhatsappCheckboxChange}
                                handleMailCheckboxChange={handleMailCheckboxChange}
                                bas={bas}
                                bass={bass}
                                setBas={setBas}
                                setBass={setBass}
                                setLanguageType={setLanguageType}
                                languageType={languageType}
                                loanNumberType={loanNumberType}
                                setLoanNumberType={setLoanNumberType}
                            />
                        </Box>
                    </Box>
                </Card>
                <Dialog open={verifyModal} maxWidth='sm' fullWidth>
                    <BusinessSelection
                        BackdropProps={{
                            sx: {
                                backdropFilter: 'blur(6px)', // You can adjust the blur intensity
                                backgroundColor: 'rgba(0, 0, 0, 0.4)' // Optional: add a semi-transparent overlay
                            }
                        }}
                        selectedOption={selectedOption}
                        setSelectedOption={setSelectedOption}
                    />
                </Dialog>
            </Container>
            <PriceDetails
                open={openPriceDetailsModal}
                onClose={() => setOpenPriceDetailsModal(false)}
                planId={planId}
                filteredPlans={filteredPlans}
                setFilteredPlans={setFilteredPlans}
                renewPlan={renewPlan}
                planData={planData}
                busUUID={busUUID}
                setBusUUID={setBusUUID}
                setPlanData={setPlanData}
                setRenewPlan={setRenewPlan}
                setRenewPlanOff={setRenewPlanOff}
                renewPlanOff={renewPlanOff}
                subUUID={subUUID}
                setSubUUID={setSubUUID}
                setProductDetails={setProductDetails}
                productDetails={productDetails}
                selectedPlanDetails={selectedPlanDetails}
                setSelectedPlanDetails={setSelectedPlanDetails}
            />
        </>
    );
};

export default ProductConfig;
